import { useState } from 'react'
import { CheckboxGroup, CheckboxField, Checkbox, Label, Input } from '@/components/ui'

export interface AssignmentItem {
  id: number
  label: string
  sublabel?: string
}

/**
 * A checkbox assignment list (users↔merchants) that stays usable as the list
 * grows: a search filter and a scrolling container appear once there are more
 * than a handful of items.
 */
export function AssignmentList({
  items,
  selected,
  onToggle,
  searchPlaceholder,
}: {
  items: AssignmentItem[]
  selected: number[]
  onToggle: (id: number, checked: boolean) => void
  searchPlaceholder?: string
}) {
  const [query, setQuery] = useState('')
  const searchable = items.length > 8

  const q = query.trim().toLowerCase()
  const filtered = q
    ? items.filter((i) => `${i.label} ${i.sublabel ?? ''}`.toLowerCase().includes(q))
    : items

  return (
    <div className="flex flex-col gap-3">
      {searchable && (
        <Input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={searchPlaceholder}
        />
      )}
      <div className={searchable ? 'max-h-64 overflow-y-auto pr-1' : undefined}>
        <CheckboxGroup>
          {filtered.map((item) => (
            <CheckboxField key={item.id}>
              <Checkbox checked={selected.includes(item.id)} onChange={(checked) => onToggle(item.id, checked)} />
              <Label>
                {item.label}
                {item.sublabel && <span className="text-text/60"> · {item.sublabel}</span>}
              </Label>
            </CheckboxField>
          ))}
        </CheckboxGroup>
      </div>
    </div>
  )
}
